import { createUseStyles } from "react-jss";
import colors from "../../constants/colors";

const styles = createUseStyles({
  mainContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    color: colors.black,
    fontFamily: "Poppins",
    fontSize: ".95rem",
    letterSpacing: 0.44,
    paddingTop: 5,
    paddingBottom: 5,
  },
  username: {
    fontFamily: "'Poppins', sans-serif",
    fontWeight: 500,
    fontSize: ".95rem",
    alignItems: "center",
    flexWrap: "wrap",
  },
  rounded: {
    borderRadius: 25,
    marginRight: 8,
    color: "black",
    backgroundColor: colors.white,
    borderColor: colors.input.border,
    borderStyle: "solid",
    borderWidth: 1,
    fontSize: ".95rem",
    padding: 5,
    margin: 3,
  },
  squared: {
    borderRadius: 10,
    marginRight: 8,
    color: "black",
    backgroundColor: colors.white,
    borderColor: colors.input.border,
    borderStyle: "solid",
    borderWidth: 1,
    fontSize: ".95rem",
    padding: 5,
    margin: 3,
  },
  adminTag: {
    fontFamily: "'Poppins', sans-serif",
    fontWeight: 500,
    fontSize: "0.8rem",
    // textTransform: 'lowercase',
    backgroundColor: colors.orange,
    color: colors.white,
    borderRadius: 3,
    marginLeft: 5,
    padding: "2px 3px",
  },
  managerTag: {
    fontFamily: "'Poppins', sans-serif",
    fontWeight: 500,
    fontSize: "0.8rem",
    // textTransform: 'lowercase',
    backgroundColor: colors.darkBlue,
    color: colors.white,
    borderRadius: 3,
    marginLeft: 5,
    padding: "2px 3px",
  },
  accountantTag: {
    fontFamily: "'Poppins', sans-serif",
    fontWeight: 500,
    fontSize: "0.8rem",
    // textTransform: 'lowercase',
    backgroundColor: colors.blue,
    color: colors.white,
    borderRadius: 3,
    marginLeft: 5,
    padding: "2px 3px",
  },
  pendingTag: {
    fontFamily: "'Poppins', sans-serif",
    fontWeight: 500,
    fontSize: "0.8rem",
    backgroundColor: colors.ashGrey,
    color: colors.white,
    borderRadius: 3,
    marginLeft: 5,
    padding: "2px 3px",
  },
});

export default styles;
